
import {Component, Vue} from 'vue-property-decorator';
import {getInvoiceByFactoryInvoice, list, page} from "@/api/invoice/index";
import {constParser, parseTime} from "@/filters";
import {INVOICE_TYPE} from "@/constant";

@Component({
  name: 'InvoiceReconciliationDesc',
})
export default class InvoiceReconciliationDesc extends Vue {

  public showDialog = false;
  public loading = false;
  public tableCol: any = [
    {
      label: "发票号码",
      prop: "code",
      key: "code"
    }
  ]
  private table = {
    list: [] as any[],
  };

  private async getList(obj) {
    if (obj.type == 'FACTORY_INVOICE') {
      this.tableCol = [
        {
          label: "发票类型",
          prop: "type",
          key: "type",
          render: (prop, row) => {
            return constParser(row.extMap?.type, INVOICE_TYPE);
          }
        },
        {
          label: "发票号码",
          prop: "receiptCode",
          key: "receiptCode"
        },
        {
          label: "绑定金额",
          prop: "allocateAmount",
          key: "allocateAmount",
        },
        {
          label: "绑定时间",
          prop: "createdTime",
          key: "createdTime",
          render: (prop, row) => {
            return parseTime(row.createdTime, "{y}-{m}-{d} {h}:{i}")
          }
        },
      ]
      const param = {receiptId: obj.id}
      getInvoiceByFactoryInvoice(param)
          .then(({data}) => {
            this.table.list = data;
            this.loading = false;
          })
    } else {
      this.tableCol = [
        {
          label: "发票号码",
          prop: "code",
          key: "code"
        }
      ]
      const param = {bookingOrderCode: obj.code}
      list(param)
          .then(({data}) => {
            console.log("data",data)
            this.table.list = data;
            this.loading = false;
          })
    }
  }

  public async openDialog(obj) {
    this.showDialog = true;
    this.getList(obj)
  }
}
